export const data =
{
    scene: '01_Rappu',
    kysymysteksti: 'Saavut Pentin kolmannessa kerroksessa sijaitsevan asunnon ovelle joka on raollaan. Ohjaajasi tulee hissillä perässä, koska hänellä on muka polvi kipeä (oikeasti hän on vain huonokuntoinen). Miten toimit? ',
    maxp: 2,
    optiot: [
        {
            id: 1,
            teksti: 'A Soitat ovikelloa ja jäät hetkeksi odottamaan',
            valinta: 'A_ovikello',
            ohjaajan_palaute: 'Kunnioitit aivan oikein asiakkaan kotia etkä rynnännyt suin päin sisälle. Ehkä ovi on unohtunut auki. ',
            koontiteksti: 'Ihan aluksi, ennen asuntoon sisälle menemistä, huomasit oven olevan auki ja mietit mitä tehdä. Päätit kunnioittaa asiakkaan kotia ja soittaa ovikelloa. Valintaasi liittyy  ammattitaitovaatimus: <i>Opiskelija työskentelee lähihoitajan työtä ohjaavien säädösten ja ohjeiden mukaan</i> ja siitä toteutui osaamiskriteeri:  <i>noudattaa sosiaali- ja terveysalan säädöksiä, säännöksiä, määräyksiä ja eettisiä periaatteita muuttuvissa tilanteissa</i>. Perustelu: tilanne oli yllättävä ja osasit kuitenkin löytää itsenäisesti eettisen ja perustellun ratkaisun. Osaamistaso tämän vaatimuksen osalta: 3.',
            pisteet: 2,
            arviointitiedosto: 'scene_01_rappu_A',
            kuva: '',
            harjoiteltava: [],
            ammattitaitovaatimukset: [
                {
                    vaatimus: 'Opiskelija työskentelee lähihoitajan työtä ohjaavien säädösten ja ohjeiden mukaan',
                    osaamistaso: 3,
                    relevantit_kriteerit: [
                        {
                            kriteeri: 'noudattaa sosiaali- ja terveysalan säädöksiä, säännöksiä, määräyksiä ja eettisiä periaatteita muuttuvissa tilanteissa',
                            toteutui: 'kyllä'
                        }
                    ]
                }

            ]
        },

        {
            id: 2,
            teksti: 'B Päättelet, että teitä selvästikin odotetaan, joten menet reippaasti suoraan sisälle',
            valinta: 'B_suoraan_sisälle',
            ohjaajan_palaute: 'Valittu B-vaihtoehto. Ei ihmisten asuntoihin voi noin vain mennä sisälle. Ei ole tietoa miksi ovi on jäänyt auki. On kunnioitettava yksityisyyttä. ',
            arviointitiedosto: 'scene_01_rappu_B',
            kuva: '',
            koontiteksti: 'Ihan aluksi, ennen asuntoon sisälle menemistä, huomasit oven olevan auki ja mietit mitä tehdä. Päätit mennä suoraan sisälle, koska oletit, että ovi on jätetty auki juuri kotihoitoa varten. Valittu toimintatapa ei kuitenkaan ollut loppuun asti mietitty - ovi on saattanut unohtua auki ja sisälle meno yllättäen voi pelästyttää asukkaat pahanpäiväisesti. Jollakin tavalla heitä pitäisi informoida saapumisesta. Valintaasi liittyy  ammattitaitovaatimus: 1) <i>Opiskelija työskentelee lähihoitajan työtä ohjaavien säädösten ja ohjeiden mukaan</i>, jonka osalta jäi toteutumatta H3-tason osaamistasokriteeri <i>Noudattaa sosiaali- ja terveysalan säädöksiä, säännöksiä, määräyksiä ja eettisiä periaatteita muuttuvissa tilanteissa</i>. Olit siis vähän ajattelematon, mutta väärinkäsitys oli toisaalta ymmärrettävä.',
            pisteet: 0,
            harjoiteltava: ['Eettiset periaatteet, asiakkaan ja tämän kodin kunnioittaminen'],
            ammattitaitovaatimukset: [
                {
                    vaatimus: 'Opiskelija työskentelee lähihoitajan työtä ohjaavien säädösten ja ohjeiden mukaan.',
                    osaamistaso: 2,
                    relevantit_kriteerit: [
                        {
                            kriteeri: 'Noudattaa sosiaali- ja terveysalan säädöksiä, säännöksiä, määräyksiä ja eettisiä periaatteita muuttuvissa tilanteissa. ',
                            toteutui: 'ei'
                        },
                    ]
                }

            ]

        }

    ]


};



